"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DataProvider", {
  enumerable: true,
  get: function get() {
    return _DataProvider.DataProvider;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "useResource", {
  enumerable: true,
  get: function get() {
    return _useResource.useResource;
  }
});
var _DataProvider = require("./DataProvider");
var _useResource = require("./useResource");
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var _default = exports.default = _DataProvider.DataProvider;